import Dropdown from "../Elements/Dropdown";
import Lottie from "lottie-react";
import { useLanguage } from "../../context/LanguageContext";
import PropTypes from "prop-types";

const GoalMetricFavCard = ({
  favouriteGoal,
  selectedYear,
  dropdown,
  lottieAnimation,
}) => {
  const { copy } = useLanguage();
  return (
    <div className="flex relative gap-2 pt-4 pr-4 pf-0 pb-0 card-base bg-white card-base-border items-center">
      <div className="h-[110px] w-[130px] overflow-hidden place-self-end">
        <Lottie
          animationData={lottieAnimation}
          loop={true}
          autoplay={true}
          className="object-cover w-full h-[100%] transform scale-x-[-1]"
        />
      </div>
      <div className="gap-1 flex flex-col w-55">
        <p className="text-sm font-headline ">{`${copy.metrics.fav} ${selectedYear}`}</p>
        <p className="text-lg">
          {favouriteGoal ? (
            <span>{favouriteGoal.title}</span>
          ) : (
            <span>Not selected</span>
          )}
        </p>
      </div>

      <div className="absolute top-4 right-2">
        <Dropdown options={dropdown()} />
      </div>
    </div>
  );
};

GoalMetricFavCard.propTypes = {
  favouriteGoal: PropTypes.object,
  selectedYear: PropTypes.number.isRequired,
  dropdown: PropTypes.func.isRequired,
  lottieAnimation: PropTypes.object.isRequired,
};

export default GoalMetricFavCard;
